const constants = require('@/util/constants')
require('./config')

/**
 * 分页获取意见反馈
 * @param {*} successcb 成功回调
 * @param {*} failedcb 失败回调
 */
export function queryFeedbacks(page, size, successcb, failedcb) {
    axios.get('api/feedback/query', {
        params: {
            'categoryId': 0,
            'page': page,
            'size': size,
            'client': constants.HTTP_CLIENT
        }
    }).then(response => {
        successcb(response.data)
    }).catch(error => {
        failedcb(error)
    })
}

